import da from 'element-ui/src/locale/lang/da'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as NumberUtils from '@/utils/NumberUtils'
export const COMPARE_MAP = {
  'lt': { '-1': true },
  'gt': { 1: true },
  'le': { 0: true, '-1': true },
  'ge': { 0: true, 1: true }
}
export class PriceFCLValidityUtil {
  static instance
  constructor() {
    this._resultMap = {}
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new PriceFCLValidityUtil()
    }
    return this.instance
  }
  isValid(configSetting, data) {
    if (configSetting === null) return true
    if (configSetting.isSumActive) {
      if (configSetting.sumDetails && configSetting.sumDetails.length > 0) {
        if (!this.checkSum(configSetting, data)) {
          return false // 存在问题
        }
      }
    }

    if (configSetting.isEQActive) {
      if (configSetting.eqDetails && configSetting.eqDetails.length > 0) {
        if (!this.checkEQ(configSetting, da)) {
          return false
        }
      }
    }

    if (configSetting.isPlaceActive) {
      if (configSetting.placeDetails && configSetting.placeDetails.length > 0) {
        if (!this.checkPlace(configSetting, data)) {
          return false // 存在问题
        }
      }
    }

    if (configSetting.isValidActive) {
      if (configSetting.validDetails && configSetting.validDetails.length > 0) {
        if (!this.checkValid(configSetting, data)) {
          return false // 存在问题
        }
      }
    }
    return true
  }
  /**
   * 检查总费用
   */
  checkSum(setting, data) {
    const cfg = setting.sumDetails[0]
    const compare = cfg.compare
    const val = Number(cfg.val)
    const sumProblems = []
    const compareMap = COMPARE_MAP[compare]
    let rs = 0
    for (const pf of data) {
      if (pf.cost20 !== PriceConstant.NIL) {
        rs = NumberUtils.numericCompare(pf.cost20, val) // 比较
        if (compareMap.hasOwnProperty(rs)) {
          sumProblems.push(pf)
          continue
        }
      }
      if (pf.cost40 !== PriceConstant.NIL) {
        rs = NumberUtils.numericCompare(pf.cost40, val) // 比较
        if (compareMap.hasOwnProperty(rs)) {
          sumProblems.push(pf)
          continue
        }
      }
      if (pf.costhc !== PriceConstant.NIL) {
        rs = NumberUtils.numericCompare(pf.costhc, val) // 比较
        if (compareMap.hasOwnProperty(rs)) {
          sumProblems.push(pf)
          continue
        }
      }
      if (pf.cost45 !== PriceConstant.NIL) {
        rs = NumberUtils.numericCompare(pf.cost45, val) // 比较
        if (compareMap.hasOwnProperty(rs)) {
          sumProblems.push(pf)
        }
      }
    }
    if (sumProblems.length > 0) {
      this._resultMap['sumProblems'] = sumProblems
      return false
    } else {
      this._resultMap['sumProblems'] = null
    }
    return true
  }
  checkEQ(setting, data) {
    const cfgs = []
    let cfg = null
    for (const eqSetting of setting.eqDetails) { // 将多条规则的compare统一按照 升序的方式排列，
      cfg = {}
      if ((eqSetting.compare).indexOf('g') > -1) { // 将大于等于换方向
        cfg.eqA = eqSetting.eqB
        cfg.eqB = eqSetting.eqA
        cfg.compare = (eqSetting.compare).replace('g', 'l')
      } else {
        cfg.eqA = eqSetting.eqA
        cfg.eqB = eqSetting.eqB
        cfg.compare = eqSetting.compare
      }
      cfgs.push(cfg)
    }
    const map = this.decodeEQSettings(cfgs)

    const eqProblems = []
    this.checkEQ_internal(eqProblems, map, data)
    if (eqProblems.length > 0) {
      this._resultMap['eqProblems'] = eqProblems
      return false
    } else {
      this._resultMap['eqProblems'] = null
    }
    return true
  }

  /**
   * 现在有5条配置45<=40HC,40HC<40GP,40GP<=40NOR,40NOR<=20GP,20GP<=20NOR<br>
   * 下面的代码主要是为了得到任意两个箱型的运价的比较关系，如45与40GP。
   */
  decodeEQSettings(cfgs) {
    const eqMap = {}
    let s = null
    // 网罗到所有的顶点
    for (const cfg of cfgs) {
      if (!eqMap[cfg.eqA]) {
        s = {}
        s['name'] = cfg.eqA
        eqMap[cfg.eqA] = s
      }
      if (!eqMap[cfg.eqB]) {
        s = {}
        s['name'] = cfg.eqB
        eqMap[cfg.eqB] = s
      }
    }
  }
  checkEQ_internal(eqProblems, map, data) {
  }
  checkPlace(setting, data) {
  }
  checkValid(setting, data) {
  }
}
